export default "__VITE_ASSET__DbbvWveP__"